import { useLocalMock } from './store'

/**
 * First value - active use mock or no
 * Second value - mocked value
 *
 * @author Ivan Shchedrovskyi
 */
type MockSearchResponse = [boolean, string | null]

/**
 * Function for get is used and mocked value of search response
 *
 * @author Ivan Shchedrovskyi
 */
export const getMockSearchResponseValue = (): MockSearchResponse => {
	return [
		useLocalMock.getState().searchResponseUsed,
		useLocalMock.getState().searchResponseValue
	]
}
